let Information = function ($http, SERVER_URL) {
  "ngInject";

  return {
    getList: getList,
    post: post,
    putString: putString,
    deleteItem: deleteItem
  }

  function getList() {
    return $http.get(SERVER_URL + `/information-by-modified-date`, {
      params: {modifiedDate: "2010-10-31T00:49:30.995Z"}
    })
  }

  function post(item) {
    return $http.post(SERVER_URL + `/information`, item)
  }

  function putString(item) {
    return $http.put(SERVER_URL + `/information-strings`, item)
  }

  function deleteItem(item) {
    return $http.delete(SERVER_URL + `/information/${item.id}`)
  }
}
export default Information;



// WEBPACK FOOTER //
// ./client/app/services/informationService/information.service.js